<template>
  <main class="app-container">
    <div :style="`height: ${height}px;`">


      <list-loading v-show="listData.loading && listData.query.page == 1" />
      <div class="no-result" v-show="!listData.loading && listData.data.length < 1">没有申请记录</div>
      <md-scroll-view
              ref="scrollView"
              :scrolling-x="false"
              @end-reached="onReachBottom"
      >
        <md-field v-for="item in listData.data"
                  :key="item.id">
          <md-detail-item title="地点" :content="item.place" />
          <md-detail-item title="日期" :content="`${item.start_day}`" />
          <md-detail-item title="时间" :content="`${item.time}`" />
          <md-detail-item title="课时" :content="item.sessions" />
          <md-detail-item title="价格(元)" :content="item.price" />
          <md-detail-item title="状态" :content="item.status" />
          <md-detail-item title="申请时间" :content="item.created_at" />
          <md-detail-item title="备注" :content="item.content" />
        </md-field>

        <md-scroll-view-more
                slot="more"
                finished-text=""
                :is-finished="listData.hasNextPage == false"
        >
        </md-scroll-view-more>
      </md-scroll-view>
    </div>

  </main>
</template>

<script>

    import { Field, DetailItem,ScrollView, ScrollViewMore } from 'mand-mobile'
    import EnrollDetail from "../../components/EnrollDetail.vue";
    import ListLoading from "../../components/ListLoading.vue";
    import listDataMixin from "../../mixins/list-data";

    export default {
        name: "CoursePlan",
        components: {
            [Field.name]: Field,
            [DetailItem.name]: DetailItem,
            [ScrollView.name]: ScrollView,
            [ScrollViewMore.name]: ScrollViewMore,
            EnrollDetail,ListLoading,
        },
        mixins: [listDataMixin],

        data() {
            return {
                apiEndpoint: 'course-plans',
                height: window.screen.height,
            }
        },
        methods: {

        },
        created() {
            this.loadListData();
        },
    };
</script>


<style lang="scss" scoped>
  .md-field{
    margin-bottom: 20px;
  }

</style>
